window.flatterDatabase = [

  // =========================
  // FENDER STYLE - 25.5"
  // =========================

  {
    brand:"Fender",
    model:"Stratocaster",
    search:["strat","stratocaster","fender strat"],
    flatter:"Fender-Style"
  },

  {
    brand:"Fender",
    model:"American Professional II Stratocaster",
    search:["american professional strat","american pro strat","pro ii strat"],
    flatter:"Fender-Style"
  },

  {
    brand:"Fender",
    model:"American Ultra Stratocaster",
    search:["american ultra strat","ultra strat"],
    flatter:"Fender-Style"
  },

  {
    brand:"Fender",
    model:"Player Stratocaster",
    search:["player strat","player series strat"],
    flatter:"Fender-Style"
  },

  {
    brand:"Fender",
    model:"Telecaster",
    search:["tele","telecaster","fender tele"],
    flatter:"Fender-Style"
  },

  {
    brand:"Fender",
    model:"American Professional II Telecaster",
    search:["american pro tele","professional ii tele"],
    flatter:"Fender-Style"
  },

  {
    brand:"Fender",
    model:"Player Telecaster",
    search:["player tele"],
    flatter:"Fender-Style"
  },

  {
    brand:"Squier",
    model:"Classic Vibe Stratocaster",
    search:["classic vibe strat","squier strat"],
    flatter:"Fender-Style"
  },

  {
    brand:"Squier",
    model:"Classic Vibe Telecaster",
    search:["classic vibe tele","squier tele"],
    flatter:"Fender-Style"
  },


  // =========================
  // GIBSON STYLE - 24.75"
  // =========================

  {
    brand:"Gibson",
    model:"Les Paul Standard",
    search:["les paul","lespaul","lp standard"],
    flatter:"Gibson-Style"
  },

  {
    brand:"Gibson",
    model:"Les Paul Studio",
    search:["les paul studio","lp studio"],
    flatter:"Gibson-Style"
  },

  {
    brand:"Gibson",
    model:"Les Paul Custom",
    search:["les paul custom","lp custom"],
    flatter:"Gibson-Style"
  },

  {
    brand:"Gibson",
    model:"SG Standard",
    search:["gibson sg","sg standard","gibson sg standard"],
    flatter:"Gibson-Style"
  },

  {
    brand:"Gibson",
    model:"ES-335",
    search:["es335","es-335","335"],
    flatter:"Gibson-Style"
  },

  {
    brand:"Epiphone",
    model:"Les Paul Standard",
    search:["epiphone les paul","epi les paul"],
    flatter:"Gibson-Style"
  },

  {
    brand:"Epiphone",
    model:"SG Standard",
    search:["epiphone sg"],
    flatter:"Gibson-Style"
  },


  // =========================
  // PRS STYLE - 25"
  // =========================

  {
    brand:"PRS",
    model:"Custom 24",
    search:["prs custom 24","custom24","prs custom"],
    flatter:"PRS-Style"
  },

  {
    brand:"PRS",
    model:"SE Custom 24",
    search:["prs se custom 24","se custom24"],
    flatter:"PRS-Style"
  },

  {
    brand:"PRS",
    model:"CE 24",
    search:["prs ce24","ce 24"],
    flatter:"PRS-Style"
  },

  {
  brand:"PRS",
  model:"Silver Sky",
  search:["prs silver sky","silver sky"],
  flatter:"Fender-Style"
},

{
  brand:"PRS",
  model:"Paul's Guitar",
  search:[
    "prs paul's guitar",
    "prs pauls guitar",
    "paul's guitar",
    "pauls guitar"
  ],
  flatter:"PRS-Style"
},


  // =========================
  // IBANEZ STYLE
  // =========================

  {
    brand:"Ibanez",
    model:"RG Series",
    search:["ibanez rg","rg550","rg570","rg series"],
    flatter:"Fender-Style"
  },

  {
    brand:"Ibanez",
    model:"AZ Series",
    search:["ibanez az","az series"],
    flatter:"Fender-Style"
  },

  {
    brand:"Ibanez",
    model:"S Series",
    search:["ibanez s series","ibanez s"],
    flatter:"Fender-Style"
  },

  {
    brand:"Ibanez",
    model:"Artcore",
    search:["ibanez artcore","artcore"],
    flatter:"Gibson-Style"
  },


  // =========================
  // YAMAHA
  // =========================

  {
    brand:"Yamaha",
    model:"Pacifica",
    search:["yamaha pacifica","pacifica"],
    flatter:"Fender-Style"
  },

  {
    brand:"Yamaha",
    model:"Revstar",
    search:["yamaha revstar","revstar"],
    flatter:"Gibson-Style"
  },


  // =========================
  // ESP / LTD
  // =========================

  

  {
    brand:"ESP LTD",
    model:"MH Series",
    search:["ltd mh","esp mh"],
    flatter:"Fender-Style"
  },

  {
    brand:"ESP LTD",
    model:"M Series",
    search:["ltd m series","esp m"],
    flatter:"Fender-Style"
  },


  // =========================
  // SCHECTER
  // =========================

  {
    brand:"Schecter",
    model:"C-1 Series",
    search:["schecter c1","c-1"],
    flatter:"Fender-Style"
  },

  {
    brand:"Schecter",
    model:"Omen Series",
    search:["schecter omen"],
    flatter:"Fender-Style"
  }  ,

  // =========================
  // BASS - 34" SCALE
  // =========================

  {
    brand:"Fender",
    model:"Jazz Bass",
    search:["jazz bass","jbass","j bass"],
    flatter:"Narrow Bass"
  },

  {
    brand:"Fender",
    model:"Precision Bass",
    search:["precision bass","p bass","pbass"],
    flatter:"Wide Bass"
  },

  {
    brand:"Squier",
    model:"Classic Vibe Jazz Bass",
    search:["squier jazz bass","classic vibe jazz"],
    flatter:"Narrow Bass"
  },

  {
    brand:"Squier",
    model:"Classic Vibe Precision Bass",
    search:["squier precision bass","squier p bass"],
    flatter:"Wide Bass"
  },

  {
    brand:"Music Man",
    model:"StingRay",
    search:["stingray","music man stingray","ray34"],
    flatter:"Wide Bass"
  },

  {
    brand:"Sterling",
    model:"Ray Series",
    search:["sterling stingray","ray4","ray34"],
    flatter:"Wide Bass"
  },

  {
    brand:"Ibanez",
    model:"SR Series 4 String",
    search:["ibanez sr","sr bass","soundgear"],
    flatter:"Narrow Bass"
  },

  {
    brand:"Yamaha",
    model:"TRBX Series",
    search:["yamaha trbx","trbx bass"],
    flatter:"Narrow Bass"
  },

  {
    brand:"Yamaha",
    model:"BB Series",
    search:["yamaha bb","bb bass"],
    flatter:"Wide Bass"
  },

  {
    brand:"Cort",
    model:"Action Bass",
    search:["cort action bass"],
    flatter:"Narrow Bass"
  },

  {
  brand:"G&L",
  model:"L-2000 Bass",
  search:["g&l l2000","g&l l-2000","l2000 bass","l 2000","l2000"],
  flatter:"Wide Bass"
},

{
  brand:"G&L",
  model:"SB-2 Bass",
  search:["g&l sb2","g&l sb-2","sb2 bass","sb2","sb-2"],
  flatter:"Wide Bass"
},

{
  brand:"Lakland",
  model:"Bass Models",
  search:["lakland","lakland bass"],
  compatible:false,
  reason:"Lakland bass models have different neck dimensions. Please contact us to confirm the correct Flatter model."
},


  // =========================
  // MORE ELECTRIC GUITARS
  // =========================

  {
    brand:"Jackson",
    model:"Dinky",
    search:["jackson dinky"],
    flatter:"Fender-Style"
  },

  {
    brand:"Jackson",
    model:"Soloist",
    search:["jackson soloist"],
    flatter:"Fender-Style"
  },

  {
    brand:"Charvel",
    model:"Pro-Mod",
    search:["charvel pro mod"],
    flatter:"Fender-Style"
  },

  {
    brand:"Music Man",
    model:"Cutlass",
    search:["music man cutlass"],
    flatter:"Fender-Style"
  },

  {
    brand:"G&L",
    model:"Legacy",
    search:["g&l legacy","legacy guitar"],
    flatter:"Fender-Style"
  },

  {
    brand:"Harley Benton",
    model:"Fusion Series",
    search:["harley benton fusion"],
    flatter:"Fender-Style"
  },

  {
    brand:"Suhr",
    model:"Classic S",
    search:["suhr classic s"],
    flatter:"Fender-Style"
  },


  // =========================
  // MORE FENDER STYLE
  // =========================

  {
    brand:"Fender",
    model:"Jaguar",
    search:["jaguar","fender jaguar"],
    flatter:"Fender-Style"
  },

  {
    brand:"Fender",
    model:"Jazzmaster",
    search:["jazzmaster","jazz master"],
    flatter:"Fender-Style"
  },

  {
    brand:"Fender",
    model:"Mustang",
    search:["mustang guitar","fender mustang"],
    flatter:"Fender-Style"
  },

  {
    brand:"Fender",
    model:"Duo-Sonic",
    search:["duo sonic","duosonic"],
    flatter:"Fender-Style"
  },

  {
  brand:"Fender",
  model:"Acoustasonic",
  search:[
    "fender acoustasonic",
    "acoustasonic",
    "acoustasonic telecaster",
    "acoustasonic stratocaster",
    "acoustasonic jazzmaster"
  ],
  flatter:"Fender-Style"
},

  {
    brand:"G&L",
    model:"ASAT",
    search:["g&l asat"],
    flatter:"Fender-Style"
  },

  {
    brand:"G&L",
    model:"S-500",
    search:["g&l s500","s500"],
    flatter:"Fender-Style"
  },

  {
    brand:"Suhr",
    model:"Classic T",
    search:["suhr classic t"],
    flatter:"Fender-Style"
  },

  {
    brand:"Suhr",
    model:"Modern",
    search:["suhr modern"],
    flatter:"Fender-Style"
  },

  {
    brand:"Tom Anderson",
    model:"Classic",
    search:["tom anderson classic"],
    flatter:"Fender-Style"
  },

  {
    brand:"Kiesel",
    model:"Delos",
    search:["kiesel delos"],
    flatter:"Fender-Style"
  },

    // =========================
  // MORE GIBSON STYLE
  // =========================

  {
    brand:"Gibson",
    model:"Flying V",
    search:["Gibson flying v","flying v guitar"],
    flatter:"Gibson-Style"
  },

  {
    brand:"Gibson",
    model:"Explorer",
    search:["Gibson explorer","explorer guitar"],
    flatter:"Gibson-Style"
  },

  {
    brand:"Gibson",
    model:"Firebird",
    search:["firebird","gibson firebird"],
    flatter:"Gibson-Style"
  },

  {
    brand:"Gibson",
    model:"SG Junior",
    search:["sg junior"],
    flatter:"Gibson-Style"
  },

  {
    brand:"Epiphone",
    model:"Casino",
    search:["epiphone casino","casino"],
    flatter:"Gibson-Style"
  },

  {
    brand:"Epiphone",
    model:"ES-335",
    search:["epiphone es335","epi 335"],
    flatter:"Gibson-Style"
  },

  {
  brand:"Epiphone",
  model:"Les Paul Custom",
  search:["epiphone les paul custom","epi les paul custom"],
  flatter:"Gibson-Style"
},


  // =========================
  // GRETSCH STYLE
  // =========================

  {
    brand:"Gretsch",
    model:"G5420T",
    search:["gretsch g5420","5420"],
    flatter:"Gibson-Style"
  },

  {
    brand:"Gretsch",
    model:"G6120",
    search:["gretsch 6120","g6120"],
    flatter:"Gibson-Style"
  },


  // =========================
  // HOLLOW BODY STYLE
  // =========================

  {
    brand:"Ibanez",
    model:"AS Series",
    search:["ibanez as","as73","as93"],
    flatter:"Gibson-Style"
  },

  {
    brand:"Epiphone",
    model:"Sheraton",
    search:["epiphone sheraton"],
    flatter:"Gibson-Style"
  },

  {
  brand:"Gibson",
  model:"Les Paul Classic",
  search:["gibson les paul classic","les paul classic"],
  flatter:"Gibson-Style"
},

    // =========================
  // MORE PRS STYLE
  // =========================

  {
    brand:"PRS",
    model:"McCarty",
    search:["prs mccarty","mccarty"],
    flatter:"PRS-Style"
  },

  {
    brand:"PRS",
    model:"McCarty 594",
    search:["mccarty 594","594"],
    flatter:"PRS-Style"
  },

  {
    brand:"PRS",
    model:"Hollowbody",
    search:["prs hollowbody","prs hollow body"],
    flatter:"PRS-Style"
  },


  // =========================
  // IBANEZ NON LOCKING NUT MODELS
  // =========================

 

  {
    brand:"Ibanez",
    model:"AZ Prestige",
    search:["ibanez az prestige","az prestige"],
    flatter:"Fender-Style"
  },

 


  // =========================
  // ESP / LTD NON LOCKING MODELS
  // =========================

  {
    brand:"ESP LTD",
    model:"EC Series",
    search:["ltd ec","esp ec","ec1000"],
    flatter:"Gibson-Style"
  },


  // =========================
  // MORE SCHECTER / JACKSON SAFE MODELS
  // =========================

  {
    brand:"Schecter",
    model:"Solo II",
    search:["schecter solo ii","solo ii"],
    flatter:"Gibson-Style"
  },

  {
    brand:"Jackson",
    model:"Monarkh",
    search:["jackson monarkh"],
    flatter:"Gibson-Style"
  },

    // =========================
  // MORE BASS MODELS - 4 STRING ONLY
  // =========================

  {
    brand:"Fender",
    model:"American Professional II Jazz Bass",
    search:["american professional jazz bass","american pro jazz bass"],
    flatter:"Narrow Bass"
  },

  {
    brand:"Fender",
    model:"American Professional II Precision Bass",
    search:["american professional precision bass","american pro p bass"],
    flatter:"Wide Bass"
  },

  {
    brand:"Music Man",
    model:"StingRay Special",
    search:["stingray special","stingray 4"],
    flatter:"Wide Bass"
  },

  {
    brand:"Sire",
    model:"V7 Jazz Bass",
    search:["sire v7","marcus miller v7"],
    flatter:"Narrow Bass"
  },

  {
    brand:"Sire",
    model:"P7 Precision Bass",
    search:["sire p7"],
    flatter:"Wide Bass"
  },

  {
    brand:"Lakland",
    model:"Jazz Bass Style",
    search:["lakland jazz","lakland 44"],
    flatter:"Narrow Bass"
  },


  // =========================
  // CLASSICAL / NYLON STRING
  // =========================

  {
    brand:"Cordoba",
    model:"Classical Guitar",
    search:["cordoba classical","cordoba nylon"],
    flatter:"Classical"
  },

  {
    brand:"Yamaha",
    model:"CG Series",
    search:["yamaha cg","yamaha classical","classical yamaha"],
    flatter:"Classical"
  },

  {
    brand:"Alhambra",
    model:"Classical Guitar",
    search:["alhambra classical"],
    flatter:"Classical"
  },


  // =========================
  // ACOUSTIC STYLE - NOT PERFECT FIT
  // =========================

  {
    brand:"Taylor",
    model:"Electric-style Neck Models",
    search:["taylor electric","taylor academy"],
    flatter:"Classical"
  },

  {
  brand:"Rickenbacker",
  model:"4003 Bass",
  search:["rickenbacker","rickenbacker 4003","4003 bass"],
  compatible:false,
  reason:"Rickenbacker 4003 uses a 33.25 inch scale and is not compatible with Flatter Gen 2."
},

{
  brand:"Hofner",
  model:"Violin Bass",
  search:["hofner","hofner violin bass","hofner bass"],
  compatible:false,
  reason:"Hofner Violin Bass models use a short scale and are not compatible with Flatter Gen 2."
},

{
  brand:"Dingwall",
  model:"Multiscale Bass",
  search:["dingwall","dingwall bass"],
  compatible:false,
  reason:"Dingwall multiscale basses are not compatible with Flatter Gen 2."
},

{
  brand:"Warwick",
  model:"Bass Models",
  search:["warwick","warwick bass","streamer","corvette","thumb bass"],
  compatible:false,
  reason:"Warwick bass models have different neck dimensions. Please contact us to confirm the correct Flatter model."
},

{
  brand:"Spector",
  model:"Bass Models",
  search:["spector","spector bass","ns bass","euro bass"],
  compatible:false,
  reason:"Spector bass models have different neck dimensions. Please contact us to confirm the correct Flatter model."
},

{
  brand:"ESP LTD",
  model:"B Series Bass",
  search:["ltd b bass","esp ltd b series","ltd b-4","ltd b-5"],
  compatible:false,
  reason:"ESP LTD B Series basses use a 35 inch scale and are not compatible with Flatter Gen 2."
}
  
];